import * as tslib_1 from "tslib";
import { CompositeChunkBase } from "./CompositeChunkBase";
/**
 * LightingCompositeBase provides a base class for diffuse methods that wrap a diffuse method to alter the
 * calculated diffuse reflection strength.
 */
var LightingCompositeChunk = (function (_super) {
    tslib_1.__extends(LightingCompositeChunk, _super);
    function LightingCompositeChunk() {
        return _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    LightingCompositeChunk.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        return this._baseChunk._getFragmentPreLightingCode(registerCache, sharedRegisters);
    };
    /**
     * @inheritDoc
     */
    LightingCompositeChunk.prototype._getFragmentCodePerLight = function (lightDirReg, lightColReg, registerCache, sharedRegisters) {
        var code = this._baseChunk._getFragmentCodePerLight(lightDirReg, lightColReg, registerCache, sharedRegisters);
        this._totalLightColorReg = this._baseChunk._totalLightColorReg;
        return code;
    };
    /**
     * @inheritDoc
     */
    LightingCompositeChunk.prototype._getFragmentCodePerProbe = function (cubeMapReg, weightRegister, registerCache, sharedRegisters) {
        var code = this._baseChunk._getFragmentCodePerProbe(cubeMapReg, weightRegister, registerCache, sharedRegisters);
        this._totalLightColorReg = this._baseChunk._totalLightColorReg;
        return code;
    };
    return LightingCompositeChunk;
}(CompositeChunkBase));
export { LightingCompositeChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/LightingCompositeChunk.js